import { AxiosInstance } from 'axios';
import * as moment from 'moment';

import { cancellable } from '../../cancellable';
import { IHistoryItem, IHistoryFilters } from 'src/views/Admin/History/types';

const DATE_FORMAT = `YYYY-MM-DDTHH:mm:ss`;
const ITEMS_PER_PAGE = 10;

const toResponse = (response: any) => {
  if (!response.success) {
    throw new Error(
      `Response failed with code ${response.statusCode}: ${
        response.errorMessage
      }`
    );
  }
  const { entries, count } = response.result;
  return {
    pageCount: Math.ceil(count / ITEMS_PER_PAGE),
    items: entries,
  };
};

const toQueryParams = (filters: IHistoryFilters) => {
  return Object.entries(filters)
    .filter(([_, value]) => Boolean(value))
    .map(([name, value]) => {
      if (name.indexOf('date') !== -1) {
        return `${name}=${moment(value).format(DATE_FORMAT)}`;
      }
      if (name === 'searchTerm') {
        return `searchWord=${value}`;
      }
      if (name === 'page') {
        return `pageSkip=${value - 1}`;
      }
      return `${name}=${value}`;
    })
    .join('&');
};

export default (api: AxiosInstance, url: string) => (
  params: IHistoryFilters
) => {
  const urlWithParams = `${url}?pageSize=${ITEMS_PER_PAGE}&${toQueryParams(
    params
  )}`;
  return cancellable<{
    pageCount: number;
    items: IHistoryItem[];
  }>((cancelOptions: any) => api.get(urlWithParams, cancelOptions), toResponse);
};



// WEBPACK FOOTER //
// ./src/services/api/admin/history/get.ts